import { getApi } from '../../../api';

export async function changePassword(user) {
  try {
    const response = await getApi().put('auth/password', { ...user }, '');

    return response;
  } catch (e) {
    return { status: e.status };
  }
}
